import { render, staticRenderFns } from "./VvFormTextInputProfil.vue?vue&type=template&id=09673d72&scoped=true&"
import script from "./VvFormTextInputProfil.vue?vue&type=script&lang=js&"
export * from "./VvFormTextInputProfil.vue?vue&type=script&lang=js&"
import style0 from "./VvFormTextInputProfil.vue?vue&type=style&index=0&id=09673d72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09673d72",
  null
  
)

export default component.exports